import Swiper, {Navigation, Mousewheel} from 'swiper';

Swiper.use([Navigation, Mousewheel]);

let swiper = new Swiper('.news-slider__items', {
    slidesPerView: 2,
    spaceBetween: 30,
    slidesPerGroup: 2,
    speed: 300,
    cssMode: true,
    loop: false,
    navigation: {
        nextEl: '.swiper-button.swiper-button--next',
        prevEl: '.swiper-button.swiper-button--prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 20
        },
        854: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
    }
});
